import { ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { DataHelper } from '@helpers/data.helper';
import { PayoutDialog } from './payout.dialog';
import { environment } from '@environments/environment';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'withdraw-auto-paypal',
  templateUrl: '../sharedTemplates/withdraw-auto-paypal.html',
})
export class WithdrawAutoPaypal implements OnInit {
  coinbaseWithdrawDatas: UntypedFormGroup;
  coinbaseDataRaw: any;

  IsChangeActive = true;
  CurrentLimit;

  constructor(
    private _changeDetection: ChangeDetectorRef,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    private _DataHelper: DataHelper,
    public dialog: MatDialog
  ) {
    this.getProcCustomerWithDrawRequestScreenResult();

    this.coinbaseWithdrawDatas = _FormBuilder.group({
      withdrawamount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.min(50), Validators.maxLength(10)]),
      paypaladdress: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.email]),
    });
  }

  ngOnInit() {
    this.coinbaseWithdrawDatas.valueChanges.subscribe(x => {
      this.coinbaseDataRaw = x;
    });
  }

  ngAfterViewInit() {
    this._UiHelper.setNavbarTitle('Paypal', true);
  }

  openPayoutDialog(): void {
    const dialogRef = this.dialog.open(PayoutDialog, {
      width: environment.mobile ? '340px' : '500px',
      height: environment.mobile ? '345px' : '240px',
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  getProcCustomerWithDrawRequestScreenResult() {
    this._ApiService.getProcCustomerWithDrawRequestScreenResult(62).then(result => {
      console.log('getProcCustomerWithDrawRequestScreenResult', result);
      this.IsChangeActive = result.IsChange;
      this.CurrentLimit = result.Amount;
    });
  }

  submitCoinbaseWithdrawData() {
    this._UiHelper.setLoadingDialog(true);

    this._ApiService.withdrawAutoPaypal(this.coinbaseDataRaw).then(result => {
      this._UiHelper.setLoadingDialog(false);
      const translator = new TranslatePipe(this._LocalizationService);
      ////console.log("COIN_BASE_WITHDRAW", result);
      if (result.code == '') {
        //return "error|System Error";
      } else {
        if (result.code == 'error') {
          this._UiHelper.errorSnackBar(result.message, '');
        } else if (result.code == 'errorcode') {
          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.errorSnackBar(t_message, '');
        } else if (result.code == 'success') {
          //window.location = result.message;

          this.openPayoutDialog();

          let t_message = translator.transform(result.message, null);
          t_message = t_message + result.description;
          this._UiHelper.successSnackBar(t_message, '');

          this.coinbaseWithdrawDatas.patchValue({ withdrawamount: '' });
          if (this._UserHelper.customerUser.CustomerId) {
            this._ApiService.getClient2().then().catch();
          }
        }
      }
    });
    this._UiHelper.setLoadingDialog(false);
  }
}
